window['ThemeSection_Product'] = ({
  product,
  variant,
  featuredMediaID,
  template,
  thumbnailsPosition,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    template: template,
    thumbnailsPosition: thumbnailsPosition,
    get addToCartText() {
      if (this.current_variant) {
        if (this.loading) {
          return window.theme.strings.loading;
        }
        if (!this.loading && this.current_variant.available) {
          if (this.template === 'product.preorder') {
            return window.theme.strings.preOrder;
          } else {
            return window.theme.strings.addToCart;
          }
        }
        if (!this.loading && !this.current_variant.available) {
          return window.theme.strings.soldOut;
        }
      } else {
        return window.theme.strings.unavailable;
      }
    },
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];
      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.current_variant && this.current_variant.title) {
        if (!this.current_variant.title.includes('Default')) {
          return this.current_variant.title;
        }
      }
      return '';
    },
    get current_price() {
      return this.current_variant.price;
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide--product');

      if (window.Splide && this.productRoot && splideEl) {
        if (
          window.slideshows &&
          window.slideshows[`${splideEl.id}`] &&
          !window.slideshows[`${splideEl.id}`].state.is(
            window.Splide.STATES.DESTROYED
          )
        ) {
          return true;
        }
      }

      return false;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }

      this.getOptions();
      this.getAddToCartButtonHeight();

      this.$watch('current_media_id', (value, oldValue) => {
        if (this.isUsingSlideshowToDisplayMedia) return;
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)
          .dispatchEvent(new CustomEvent('mediaHidden'));
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${value}"]`)
          .dispatchEvent(new CustomEvent('mediaVisible'));
      });

      this.updateStoreAvailability(this.current_variant);
    },
    getAddToCartButtonHeight() {
      window.onload = function () {
        const height = document.querySelector('.add-to-cart-btn').offsetHeight;
        document.documentElement.style.setProperty(
          '--payment-button-height',
          `${height}px`
        );
      };
    },
    updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;
      this.storeAvailability =
        this.storeAvailability ||
        new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    optionChange() {
      this.getOptions();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );

      this.current_variant = matchedVariant;

      if (this.current_variant) {
        variantLiveRegion(this.current_variant);
        this.updateStoreAvailability(this.current_variant);

        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
        const url = ShopifyProductForm.getUrlWithVariant(
          window.location.href,
          this.current_variant.id
        );

        window.history.replaceState({ path: url }, '', url);
        this.$refs.singleVariantSelector.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        this.$root.dispatchEvent(
          new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: this.current_variant },
          })
        );
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            console;
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    changeMedia(direction) {
      this.$root.dispatchEvent(
        new CustomEvent('shapes:product:arrow-change', {
          bubbles: true,
          detail: { direction: direction },
        })
      );
      if (this.thumbnailsPosition == 'under') {
        const currentThumbnail = this.$root.querySelector(
          '.product-thumbnail-list-item--active'
        );
        const nextElement =
          direction == 'prev'
            ? currentThumbnail.previousElementSibling
            : currentThumbnail.nextElementSibling;
        if (nextElement !== null) {
          nextElement.querySelector('.media-thumbnail').click();
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(this.$refs.productForm);

      let modalCart = theme.settings.cart_type === 'modal';

      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;
            throw data.description;
          }
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          if (typeof error === 'string') {
            alert(error);
          } else {
            error.json().then((a) => {
              this.loading = false;
              alert(a.description);
            });
          }
        });
    },
    openZoom(index) {
      this.$refs.photoSwipeComponent.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: index,
          },
        })
      );
    },
  };
};

window['productThumbnails'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.splide__track'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.firstVisible = true;
          } else {
            this.firstVisible = false;
          }
        },
        options
      );
      const lastThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.lastVisible = true;
          } else {
            this.lastVisible = false;
          }
        },
        options
      );
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};

var observeDOM = (function() {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function(obj, callback) {
    if (!obj || obj.nodeType !== 1) {
      return;
    }

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, {childList: true, subtree: true});
      return mutationObserver;
    } else if (window.addEventListener) { // browser support fallback
      obj.addEventListener('DOMNodeInserted', callback, false);
      obj.addEventListener('DOMNodeRemoved', callback, false);
    }
  }
})();

var widgetContainer = document.querySelector('.recharge-subscription-widget');
let observer = observeDOM(widgetContainer, function(m) {
  var find = document.querySelector('.onetime-radio');
  
  if (document.contains(find)) {
    if(__productWizRioProduct.compare_at_price){
      let compareAt = formatMoney(__productWizRioProduct.compare_at_price);
      let newPrice = formatMoney(__productWizRioProduct.price);
      document.querySelector(".onetime-radio .price-label").innerHTML = `<div style='text-decoration: line-through;color: gray;font-size: 0.7em;'>${compareAt}</div> ${newPrice}`;
    }
    observer.disconnect();
  }
});

function enrichCartDetail(formData){

  const config = fetchConfigDefaults('javascript');

  config.body = formData;
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  fetch(`${theme.routes.cart_change_url}.js`, config)
    .then((res) => res.json())
    .then(async (data) => {

      //console.log(data)
    })

}

document.addEventListener('rebuy:cart.enriched', (event) => { 
  event.detail.cart.cart.items.forEach(item=>{
    switch(item.handle){
      case '4-pack-sub-only': 
        if(item.properties['__bundle_selection'] == undefined){
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('key', item.key);
          formData.append('properties[Flavor 1]','Fresh Mint');
          formData.append('properties[Flavor 2]','Vanilla Frosting');
          formData.append('properties[Flavor 3]','Sweet Orange');
          formData.append('properties[Flavor 4]','Mint Brownie');
          formData.append('properties[__bundle_selection]','Fresh Mint <> Vanilla Frosting <> Sweet Orange <> Mint Brownie');
          enrichCartDetail(formData);
        }
      break;
      case 'happy-tooth-toothpaste-3-pack-pre-selected-flavors':
        if(item.properties['__bundle_selection'] == undefined){
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('key', item.key);
          formData.append('properties[Flavor 1]','Fresh Mint');
          formData.append('properties[Flavor 2]','Vanilla Frosting');
          formData.append('properties[Flavor 3]','Sweet Orange');
          formData.append('properties[__bundle_selection]','Fresh Mint <> Vanilla Frosting <> Sweet Orange ');
          enrichCartDetail(formData);
        }
      break;
      case 'natural-toothpaste-3-pack':
      case 'hydroxyapatite-toothpaste-3-pack':
        if(item.properties['__bundle_selection'] == undefined){

          let str = item.properties['Flavor 1'] +' <> '+ item.properties['Flavor 2'] + ' <> ' + item.properties['Flavor 3'];

          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('key', item.key);
          formData.append('properties[Flavor 1]',item.properties['Flavor 1']);
          formData.append('properties[Flavor 2]',item.properties['Flavor 2']);
          formData.append('properties[Flavor 3]',item.properties['Flavor 3']);
          formData.append('properties[__bundle_selection]',str);
          enrichCartDetail(formData);
        }
      break;
      case 'variety-4-pack':
        if(item.properties['__bundle_selection'] == undefined){

          let str = item.properties['Flavor 1'] + ' <> ' + item.properties['Flavor 2'] + ' <> ' + item.properties['Flavor 3'] + ' <> ' + item.properties['Flavor 4'];

          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('key', item.key);
          formData.append('properties[Flavor 1]',item.properties['Flavor 1']);
          formData.append('properties[Flavor 2]',item.properties['Flavor 2']);
          formData.append('properties[Flavor 3]',item.properties['Flavor 3']);
          formData.append('properties[Flavor 4]',item.properties['Flavor 4']);
          formData.append('properties[__bundle_selection]',str);
          enrichCartDetail(formData);
        }
      break;
    case '3-pack-subscription-20-gift-card':
        if(item.properties['__bundle_selection'] == undefined){
          let str = 'Fresh Mint <> Vanilla Frosting <> Sweet Orange';

          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('key', item.key);
          formData.append('properties[Flavor 1]', 'Fresh Mint');
          formData.append('properties[Flavor 2]', 'Vanilla Frosting');
          formData.append('properties[Flavor 3]', 'Sweet Orange');
          formData.append('properties[__bundle_selection]',str);
          enrichCartDetail(formData);
        }
      break;
    }
  })
});